const question6 = {
    'question': 'W jaki sposób diagnozuje się autyzm?',
    'answer': 'Diagnoza autyzmu jest złożonym procesem, który wymaga oceny pacjenta przez zespół specjalistów. Diagnoza opiera się na obserwacji dziecka, wywiadzie z rodzicami i dzieckiem oraz na wynikach testów diagnostycznych. W przypadku diagnozy autyzmu u dorosłych proces może być podobny, ale może obejmować również rozmowy z członkami rodziny lub przyjaciółmi dorosłego, aby uzyskać więcej informacji na temat jego rozwoju i objawów.',
}

export default question6;